import { SnapSelectMenuOption } from "@snap-mobile/snap-ui/dist/types/utils";

export const BUSINESS_TYPES: SnapSelectMenuOption[] = [
  { value: "non_profit", name: "Non Profit", selected: true },
  { value: "company", name: "Company", selected: false },
  { value: "government_entity", name: "Government Entity", selected: false },
];

export const BUSINESS_STRUCTURES: Record<string, SnapSelectMenuOption[]> = {
  company: [
    {
      value: "sole_proprietorship",
      name: "Sole Proprietorship",
      selected: true,
    },
    { value: "single_member_llc", name: "Single Member LLC", selected: false },
    { value: "multi_member_llc", name: "Multi Member LLC", selected: false },
    {
      value: "private_partnership",
      name: "Private Partnership",
      selected: false,
    },
    {
      value: "unincorporated_association",
      name: "Unincorporated Association",
      selected: false,
    },
    {
      value: "public_partnership",
      name: "Public Partnership",
      selected: false,
    },
    {
      value: "public_corporation",
      name: "Public Corporation",
      selected: false,
    },
  ],

  non_profit: [
    {
      value: "incorporated_non_profit",
      name: "Incorporated Non Profit",
      selected: true,
    },
    {
      value: "unincorporated_non_profit",
      name: "Unincorporated Non Profit",
      selected: false,
    },
  ],

  government_entity: [
    {
      value: "government_instrumentality",
      name: "Government Instrumentality",
      selected: true,
    },
    { value: "governmental_unit", name: "Governmental Unit", selected: false },
    {
      value: "tax_exempt_government_instrumentality",
      name: "Tax Exempt Government Instrumentality",
      selected: false,
    },
  ],
};

export const STATES: SnapSelectMenuOption[] = [
  { value: "AL", name: "Alabama", selected: true },
  { value: "AK", name: "Alaska", selected: false },
  { value: "AZ", name: "Arizona", selected: false },
  { value: "AR", name: "Arkansas", selected: false },
  { value: "CA", name: "California", selected: false },
  { value: "CO", name: "Colorado", selected: false },
  { value: "CT", name: "Connecticut", selected: false },
  { value: "DE", name: "Delaware", selected: false },
  { value: "FL", name: "Florida", selected: false },
  { value: "GA", name: "Georgia", selected: false },
  { value: "HI", name: "Hawaii", selected: false },
  { value: "ID", name: "Idaho", selected: false },
  { value: "IL", name: "Illinois", selected: false },
  { value: "IN", name: "Indiana", selected: false },
  { value: "IA", name: "Iowa", selected: false },
  { value: "KS", name: "Kansas", selected: false },
  { value: "KY", name: "Kentucky", selected: false },
  { value: "LA", name: "Louisiana", selected: false },
  { value: "ME", name: "Maine", selected: false },
  { value: "MD", name: "Maryland", selected: false },
  { value: "MA", name: "Massachusetts", selected: false },
  { value: "MI", name: "Michigan", selected: false },
  { value: "MN", name: "Minnesota", selected: false },
  { value: "MS", name: "Mississippi", selected: false },
  { value: "MO", name: "Missouri", selected: false },
  { value: "MT", name: "Montana", selected: false },
  { value: "NE", name: "Nebraska", selected: false },
  { value: "NV", name: "Nevada", selected: false },
  { value: "NH", name: "New Hampshire", selected: false },
  { value: "NJ", name: "New Jersey", selected: false },
  { value: "NM", name: "New Mexico", selected: false },
  { value: "NY", name: "New York", selected: false },
  { value: "NC", name: "North Carolina", selected: false },
  { value: "ND", name: "North Dakota", selected: false },
  { value: "OH", name: "Ohio", selected: false },
  { value: "OK", name: "Oklahoma", selected: false },
  { value: "OR", name: "Oregon", selected: false },
  { value: "PA", name: "Pennsylvania", selected: false },
  { value: "RI", name: "Rhode Island", selected: false },
  { value: "SC", name: "South Carolina", selected: false },
  { value: "SD", name: "South Dakota", selected: false },
  { value: "TN", name: "Tennessee", selected: false },
  { value: "TX", name: "Texas", selected: false },
  { value: "UT", name: "Utah", selected: false },
  { value: "VT", name: "Vermont", selected: false },
  { value: "VA", name: "Virginia", selected: false },
  { value: "WA", name: "Washington", selected: false },
  { value: "WV", name: "West Virginia", selected: false },
  { value: "WI", name: "Wisconsin", selected: false },
  { value: "WY", name: "Wyoming", selected: false },
];

export const TITLES: SnapSelectMenuOption[] = [
  {
    value: "athletic_director",
    name: "Athletic Director",
    selected: true,
  },
  { value: "coach", name: "Coach", selected: false },
  { value: "director", name: "Director", selected: false },
  {
    value: "financial_administrator",
    name: "Financial Administrator",
    selected: false,
  },
  { value: "teacher", name: "Teacher", selected: false },
  { value: "team_manager", name: "Team Manager", selected: false },
  { value: "controller", name: "Controller", selected: false },
  { value: "vp", name: "VP", selected: false },
  { value: "avp", name: "AVP", selected: false },
  { value: "treasurer", name: "Treasurer", selected: false },
  { value: "secretary", name: "Secretary", selected: false },
  { value: "bookkeeper", name: "Bookkeeper", selected: false },
  { value: "ceo", name: "CEO", selected: false },
  { value: "cfo", name: "CFO", selected: false },
  { value: "coo", name: "COO", selected: false },
  { value: "cio", name: "CIO", selected: false },
  { value: "president", name: "President", selected: false },
  { value: "benefits", name: "Benefits", selected: false },
  { value: "executive", name: "Executive", selected: false },
  { value: "chairman", name: "Chairman", selected: false },
  { value: "manager", name: "Manager", selected: false },
  { value: "partner", name: "Partner", selected: false },
  { value: "member", name: "Member", selected: false },
];

export const BUSINESS_STRUCTURES_THAT_REQUIRE_OWNERS = [
  "multi_member_llc",
  "private_partnership",
  "unincorporated_association",
  "sole_proprietorship",
  "single_member_llc",
];

export const DEFAULT_PERCENT_OWNERSHIP = 25;
